import type { Status } from "."

export const STATUS: Record<Uppercase<Status>, Status> = {
  DISMISSED: "dismissed",
  OPEN: "open",
  PROCESSING: "processing",
  RESOLVED: "resolved",
  DISMISSED_RESOLVED: "dismissed_resolved"
} as const
